import { render } from "./SetItem.vue?vue&type=template&id=56ccd3f8"
import script from "./SetItem.vue?vue&type=script&lang=js"
export * from "./SetItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__